import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { ControlledModal as Component } from './controlled/desktop';
import type { TControlledPropsDesktop, IControlledDepsDesktop } from './controlled/models';
import { ModalDesktop as Modal } from './desktop';

export const ControlledModalDesktop = createWidget<IControlledDepsDesktop, TControlledPropsDesktop>(
    {
        Modal,
    }
)(Component);
